import { z } from "zod";

export const redirectUriSettingsSchema = z.object({
  allowedRedirectUris: z.array(
    z.object({
      // Allow empty rows (they are dropped on submit); validate non-empty entries as URLs
      value: z.string().trim().url("Enter a valid URL").or(z.literal("")),
    })
  ),
});
